<template>
    <div class="taxlawSearch">
        <!-- 搜索模块 -->
      <div class="search">
        <div
          :style="{
            marginLeft: searchBol == true ? '0px' : '229px',
            width: searchBol == true ? '800px' : '',
            display: searchBol == true ? 'inline-block' : 'block',
          }"
        >
          <div style="margin-bottom: 20px" v-if="false">
            <el-button
              type="text"
              style="
                font-size: 18px;
                color: #3d3d3d;
                line-height: 20px;
                padding: 0 10px 10px;
                margin: 0 28px;
              "
              :class="{ btnTypeTree: btnTypeNum == 1 }"
              @click="btnTypeFun(1)"
              >查全文</el-button
            >
            <el-button
              type="text"
              style="
                font-size: 18px;
                color: #3d3d3d;
                line-height: 20px;
                padding: 0 10px 10px;
                margin: 0 28px;
              "
              :class="{ btnTypeTree: btnTypeNum == 2 }"
              @click="btnTypeFun(2)"
              >查标题</el-button
            >
            <el-button
              type="text"
              style="
                font-size: 18px;
                color: #3d3d3d;
                line-height: 20px;
                padding: 0 10px 10px;
                margin: 0 28px;
              "
              :class="{ btnTypeTree: btnTypeNum == 3 }"
              @click="btnTypeFun(3)"
              >查文号</el-button
            >
            <el-button
              type="text"
              style="
                font-size: 18px;
                color: #3d3d3d;
                line-height: 20px;
                padding: 0 10px 10px;
                margin: 0 28px;
              "
              :class="{ btnTypeTree: btnTypeNum == 4 }"
              @click="btnTypeFun(4)"
              >查时间</el-button
            >
          </div>
          <div>
            <div v-if="btnTypeNum == 1">
              <!-- 搜索框 -->
              <div
                style="width: 775px; display: inline-block; vertical-align: top;visibility: hidden;"
              >
                <el-input
                  v-model="content"
                  @input="fillHotWords(1)"
                  placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"
                  class="searchInput"
                  style="width: calc(100% -150px)"
                >
                </el-input>
                <el-button type="primary" class="searchType" @click="go(1)"
                  ><span
                    style="
                      font-size: 18px;
                      font-weight: bold;
                      line-height: 18px;
                      color: #ffffff;
                    "
                    >搜 索</span
                  >
                </el-button>
              </div>
              <div class="goHomeCss" style="100px;display:inline-block" @click="home()">
                <span
                  style="
                    font-size: 20px;
                    line-height: 60px;
                    color: #0f59a4;
                    font-weight: 700;
                    cursor: pointer;
                  "
                >
                  <i class="el-icon-s-home" style="margin-right: 8px"></i>
                  <span>首页</span>
                </span>
              </div>
            </div>
            <div v-if="btnTypeNum == 2">
              <!-- 搜索框 -->
              <div
                style="width: 775px; display: inline-block; vertical-align: top"
              >
                <el-input
                  v-model="title"
                  @input="fillHotWords(2)"
                  placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"
                  class="searchInput"
                  style="width: calc(100% -150px)"
                >
                </el-input>
                <el-button type="primary" class="searchType" @click="go(2)"
                  ><span
                    style="
                      font-size: 18px;
                      font-weight: bold;
                      line-height: 18px;
                      color: #ffffff;
                    "
                    >搜 索</span
                  ></el-button
                >
              </div>
              <div style="100px;display:inline-block" @click="home()">
                <span
                  style="
                    font-size: 20px;
                    line-height: 60px;
                    color: #0f59a4;
                    font-weight: 700;
                    cursor: pointer;
                  "
                >
                  <i class="el-icon-s-home" style="margin-right: 8px"></i>
                  <span>首页</span>
                </span>
              </div>
            </div>
            <div v-if="btnTypeNum == 3">
              <!-- 搜索框 -->
              <div
                style="width: 775px; display: inline-block; vertical-align: top"
              >
                <el-input
                  v-model="wenhao"
                  @input="fillHotWords(3)"
                  placeholder="请输入文号，用空格分开，例如：2016 36"
                  class="searchInput"
                  style="width: calc(100% -150px)"
                >
                </el-input>
                <el-button type="primary" class="searchType" @click="go(3)"
                  ><span
                    style="
                      font-size: 18px;
                      font-weight: bold;
                      line-height: 18px;
                      color: #ffffff;
                    "
                    >搜 索</span
                  ></el-button
                >
              </div>
              <div style="100px;display:inline-block" @click="home()">
                <span
                  style="
                    font-size: 20px;
                    line-height: 60px;
                    color: #0f59a4;
                    font-weight: 700;
                    cursor: pointer;
                  "
                >
                  <i class="el-icon-s-home" style="margin-right: 8px"></i>
                  <span>首页</span>
                </span>
              </div>
            </div>
            <div v-if="btnTypeNum == 4">
              <!-- 搜索框 -->
              <div
                class="searchClass"
                style="width: 775px; display: inline-block; vertical-align: top"
              >
                <div
                  @keydown="showKeyCode"
                  style="display: inline-block; vertical-align: top"
                >
                  <el-date-picker
                    v-if="timeKey == false"
                    v-model="startPublicDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="开始日期"
                  >
                  </el-date-picker>
                </div>
                <el-input
                  prefix-icon="el-icon-date"
                  @blur="startTime"
                  v-if="timeKey"
                  v-model="startPublicDate"
                  placeholder="开始日期"
                  :autofocus="timeKey"
                ></el-input>
                <span
                  style="line-height: 58px; height: 58px; margin-right: 12px"
                  >至</span
                >
                <div
                  @keydown="showKeyCodeEnd"
                  style="display: inline-block; vertical-align: top"
                >
                  <el-date-picker
                    v-if="timeKeyEnd == false"
                    v-model="endPublicDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="结束日期"
                  >
                  </el-date-picker>
                </div>
                <el-input
                  prefix-icon="el-icon-date"
                  @blur="endTime"
                  v-if="timeKeyEnd"
                  v-model="endPublicDate"
                  placeholder="结束日期"
                  :autofocus="timeKeyEnd"
                ></el-input>
                <el-button type="primary" class="searchType" @click="go(4)"
                  ><span
                    style="
                      font-size: 18px;
                      font-weight: bold;
                      line-height: 18px;
                      color: #ffffff;
                    "
                    >搜 索</span
                  ></el-button
                >
              </div>
              <div style="100px;display:inline-block" @click="home()">
                <span
                  style="
                    font-size: 20px;
                    line-height: 60px;
                    color: #0f59a4;
                    font-weight: 700;
                    cursor: pointer;
                  "
                >
                  <i class="el-icon-s-home" style="margin-right: 8px"></i>
                  <span>首页</span>
                </span>
              </div>
            </div>
            <!--搜索联想-->
            <div class="searchLenovo" v-if="searchArticleNo !== ''">
              <div class="sLevovoTitle">搜索联想</div>
              <div class="sLevovoKey">{{ searchArticleNo }}:</div>
              <div class="sLevovoRight">
                <div class="sLenovoScroll_3" v-if="list.length != 0">
                  <template v-for="(item, index) in list">
                    <span
                      @click="lenovoCheck(item)"
                      class="textList_3"
                      v-html="item.highlight"
                      :key="index"
                    ></span>
                  </template>
                </div>
                <div class="sLenovoScroll1" v-if="list.length == 0">
                  未获取检索联想词
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>


// 发送方组件
import { EventBus } from '@/assets/js/event-bus.js';

export default {
    name:'taxlawSearch',
    data(){
        return{
            //图片地址
            imgObj:{
            },
            searchBol: false,
            btnTypeNum: 1,
            //搜索框的所需字段
            content: '',
            title: '',
            wenhao: '',
            startPublicDate: '',
            endPublicDate: '',
            timeKey: false,
            timeKeyEnd: false,
            list: [],
            iflianxiang: false,
            able: '',
            lianxiangif: 1,
            // 关键词列表
            keyWordList: [],
            // 搜索类型 1正文 2标题 3文号
            searchType: '',
            // 设置一个判定当前联系词隶属于那个搜索框的值 默认值为1 1：正文 2：标题 3：文号
            inputType: 1,
            //选择的联想词 正文
            searchText: '',
            // 选择的联想词 标题
            searchTitle: '',
            // 选择的联想词 文号
            searchArticleNo: '',
            //搜索框的所需字段
        }
    },
    methods:{
        home(){
          this.$router.push('/');
          //跨组件通讯
          EventBus.$emit('dataForOtherRoute', {path:''});
        },
        btnTypeFun(v) {
            this.btnTypeNum = v
        },
        go(){
            
        },
        fillHotWords(){

        },
        showKeyCode(){

        },
        showKeyCodeEnd(){

        }
    },
    
}
</script>
<style lang="scss" scoped>

.goHomeCss{
  position: relative;
  top:0px;
  left:100px;
}

.taxlawSearch{
    width:100%;
    max-height:195px;
    padding-top:40px;
    background: #F3F8FC;
    box-sizing: border-box;
}
/***新增搜索框的样式 */
.search {
  width: 1200px;
  height: auto;
  margin: 0px auto;
  padding: 20px 0;
  background: #ffffff;

  height: 0px;
  box-sizing: border-box;
  padding:0;
}
.btnTypeTree {
  border-bottom: 4px solid #0f59a4 !important;
  color: #0f59a4 !important;
  font-weight: 700 !important;
}
.searchInput {
  width: calc(100% - 175px) !important;
  margin-right: 10px;
}
.searchClass ::v-deep .el-date-editor.el-input {
  width: 277px;
  margin-right: 10px;
  height: 54px !important;
  border-radius: 0 !important;
  border: 2px solid #0f59a4 !important;
  vertical-align: top;
}
.searchClass ::v-deep .el-input__inner {
  line-height: 54px !important;
  height: 54px !important;
  border-radius: 0 !important;
}
.el-range-separator {
  line-height: 48px;
}

.searchClass ::v-deep .el-input {
  width: 190px;
  margin-right: 10px;
  height: 54px !important;
  border-radius: 0 !important;
  border: 2px solid #0f59a4 !important;
  vertical-align: top;
}
.searchInput ::v-deep  .el-input__inner {
  height: 58px !important;
  border-radius: 0 !important;
  border: 2px solid #0f59a4 !important;
}



.searchInput {
  background: #fff;
  margin-right: 10px;
}

.searchType {
  width: 140px;
  height: 58px;
  text-align: center;
  background: #0f59a4 !important;
  border: #0f59a4 !important;
  border-radius: 0 !important;
  vertical-align: top;
}

.searchType span {
  font-weight: 700;
  line-height: 18px;
}


</style>
